<template>
  <OffSetDefault
        id="offset-consentimientos"
        title="Consetimientos requeridos"
        size="md"
      >
    <template #body>
      <!-- Modo admisión: consentimiento general (sin servicio), asociado a la admisión -->
      <DocumentosListDefault
        v-if="sinServicio"
        firmas-buttons=""
        :parametros="parametros"
        cofo-tipo-documento="CONSENTIMIENTOS"
        :cofo-sitio-diligencia="origen"
        :sin-servicio="true"
        :ciad-id="ciadId"
        :ciad-tipo-estado="ciadTipoEstado"
      >
        <template #firmasPadrebuttons="{firma}">
            <TooltipDefault label="Datos paciente"><ButtonDefault class="mx-2" color="blue" size="xs" @click="setDatosPaciente(firma)"><UserCircleIcon class="h-6 w-6 text-blue-500 cursor-pointer" /></ButtonDefault></TooltipDefault>
        </template>
      </DocumentosListDefault>
      <!-- Modo atención: consentimiento atado al servicio de la tecnología -->
      <DocumentosListDefault v-else firmas-buttons="" :parametros="parametros" cofo-tipo-documento="CONSENTIMIENTOS" :cofo-sitio-diligencia="origen" :citt-id="technologia?.cittId" :cose-id="(technologia?.contratoxservicio?.coseId as number)" :cocu-id="(technologia?.contratoxservicio?.cocuId as number)" :ciad-tipo-estado="ciadTipoEstado">
        <template #firmasPadrebuttons="{firma}">
            <TooltipDefault label="Datos paciente"><ButtonDefault class="mx-2" color="blue" size="xs" @click="setDatosPaciente(firma)"><UserCircleIcon class="h-6 w-6 text-blue-500 cursor-pointer" /></ButtonDefault></TooltipDefault>
        </template>
      </DocumentosListDefault>
    </template>
  </OffSetDefault>
</template>
<script setup lang="ts">
import DocumentosListDefault from '@/modules/Configuracion/components/Documentos/DocumentosListDefault.vue'
import type { ICitaTechnologiasSalud } from '../interfaces';
import type { IConfDocjsonparametros } from '@/modules/Configuracion/interfaces/tablas/IConfDocjsonparametros';
import type { IDocumentoFirma } from '@/modules/Configuracion/interfaces/IDocumento';
import { UserCircleIcon } from '@heroicons/vue/24/outline'

withDefaults(defineProps<{
  parametros: IConfDocjsonparametros[]
  setDatosPaciente: (firma: IDocumentoFirma) => void
  origen: string
  technologia?: ICitaTechnologiasSalud
  ciadId?: number
  sinServicio?: boolean
  ciadTipoEstado?: string | null
}>(), {
  sinServicio: false,
  ciadTipoEstado: null
})
</script>
